import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { StepPair, stepsApi } from 'api';
import { usePanel } from 'contexts/panelContext';
import { userDisplayName } from 'utils/userDisplayName';

export type ProgressPairSteps = {
	label: string;
	pairId: number;
	activeStep: number;
	steps: StepPair[] | null;
	secondStage: boolean;
};

export const useProgressSteps = () => {
	const { currentApplicationData, panelType } = usePanel();

	const { data, refetch, isFetching, isFetched, isLoading } = useQuery(
		['steps', { applicationId: currentApplicationData?.id, panelType }],
		() =>
			stepsApi.getSteps({
				applicationId: Number(currentApplicationData?.id),
			}),
		{
			refetchInterval: 120000,
			refetchOnWindowFocus: false,
			enabled: true,
			onError: () => {
				//
			},
		}
	);

	const currentPairsSteps: ProgressPairSteps[] | null = useMemo(() => {
		if (data && Array.isArray(data) && data.length > 0) {
			return data.map(({ pair, ...restData }) => {
				return {
					...restData,
					label: userDisplayName(
						currentApplicationData.applicationRole === 'mentee'
							? pair.mentorMembership.user
							: pair.menteeMembership.user
					),
				};
			});
		}
		return null;
	}, [currentApplicationData.applicationRole, data]);

	const commonSteps = useMemo(() => {
		if (data && !Array.isArray(data)) {
			return data;
		}
		return null;
	}, [data]);

	return {
		refetch,
		data,
		isLoading,
		isFetching,
		isFetched,
		currentPairsSteps,
		commonSteps,
	};
};
